'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import SvgCheck from '@common/icon/SvgCheck';
import { cn } from '@core/utils';
interface FilterSelectableListProps<T extends string | number> {
  options: {
    value: T;
    label: string;
  }[];
  selectedValue: T | null;
  onSelect: (value: T | null) => void;
  allowClear?: boolean;
  allLabel?: string;
  disabled?: boolean;
  isLoading?: boolean;
  skeletonCount?: number;
}
export function FilterSelectableList(t0) {
  const $ = _c(17);
  const {
    options,
    selectedValue,
    onSelect,
    allowClear: t1,
    allLabel: t2,
    disabled: t3,
    isLoading: t4,
    skeletonCount: t5
  } = t0;
  const allowClear = t1 === undefined ? false : t1;
  const allLabel = t2 === undefined ? "\uC804\uCCB4" : t2;
  const disabled = t3 === undefined ? false : t3;
  const isLoading = t4 === undefined ? false : t4;
  const skeletonCount = t5 === undefined ? 6 : t5;
  if (isLoading) {
    let t6;
    if ($[0] !== skeletonCount) {
      t6 = <>{Array.from({
          length: skeletonCount
        }, _temp)}</>;
      $[0] = skeletonCount;
      $[1] = t6;
    } else {
      t6 = $[1];
    }
    return t6;
  }
  let t6;
  if ($[2] !== allLabel || $[3] !== allowClear || $[4] !== options) {
    t6 = allowClear ? [{
      value: null,
      label: allLabel
    }, ...options] : options;
    $[2] = allLabel;
    $[3] = allowClear;
    $[4] = options;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const allOptions = t6;
  let t7;
  if ($[6] !== allOptions || $[7] !== disabled || $[8] !== onSelect || $[9] !== selectedValue) {
    let t8;
    if ($[11] !== disabled || $[12] !== onSelect || $[13] !== selectedValue) {
      t8 = t9 => {
        const {
          value,
          label
        } = t9;
        const isSelected = selectedValue === value;
        return <button key={value ?? "__all__"} type="button" aria-pressed={isSelected} disabled={disabled} onClick={() => onSelect(value)} className={cn("flex items-center justify-between gap-8 py-4 text-left text-Gray-800 transition-colors duration-150 typo-body4 disabled:opacity-40", isSelected ? "font-600 text-B-600" : "hover:text-Gray-black")}><span>{label}</span>{isSelected ? <SvgCheck aria-hidden={true} className="size-16 shrink-0 stroke-B-600 text-B-600" strokeWidth={1} /> : null}</button>;
      };
      $[11] = disabled;
      $[12] = onSelect;
      $[13] = selectedValue;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    t7 = allOptions.map(t8);
    $[6] = allOptions;
    $[7] = disabled;
    $[8] = onSelect;
    $[9] = selectedValue;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <>{t7}</>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(_, index) {
  return <div key={index} className="flex items-center py-4"><Skeleton typo="body4" className="w-3/5 rounded-xxsmall" /></div>;
}